import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ViewInventryDetails } from "../../../redux/services/InventryTransferService/inventory.Services";
import { errorToast } from "../../../Utils/toast";
import { Link } from "react-router-dom";
import Pagination from "../../../common/Pagination";

function ViewInventryDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [productData, setProductData] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalPages, setTotalPages] = useState(1);
  const [showProducts, setShowProducts] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const imageUrl = "https://crm.a2logicgroup.com/admin/uploads/product";

  const fetchProductData = async (pageNum = 1, isInitial = true) => {
    try {
      if (isInitial) {
        setIsLoading(true);
      } else {
        setTableLoading(true);
      }
      
      const payload = { id: id, page: pageNum, limit: limit };
      const response = await ViewInventryDetails(payload);

      if (response?.success) {
        setProductData(response.data.transfer || []);
        setPage(response?.current_page || 1);
        setTotalPages(response?.last_page || 1);
      } else {
        errorToast(response?.data?.message);
        navigate("/transfer-inventroy-list");
      }
    } catch (error) {
      console.log("Error fetching product:", error);
      errorToast("Failed to load product data");
      navigate("/transfer-inventroy-list");
    } finally {
      setIsLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchProductData(1, true);
  }, [limit]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchProductData(newPage, false);
    }
  };

  const handleBack = () => {
    navigate("/transfer-inventroy-list");
  };

  // Loading state
  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading product details...</p>
          </div>
        </div>
      </div>
    );
  }

  // If no data, show error
  if (!productData) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center py-5">
            <div className="alert alert-danger">Product not found</div>
            <button className="btn btn-primary" onClick={handleBack}>
              Back to Products
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>View Inventory</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>View inventory</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={handleBack}>
            Back
          </button>
        </div>
      </div>
      <div className="main_page">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">From WhereHouse</label>
            <input
              type="text"
              className="form-control"
              value={productData?.from_warehouse?.warehouse_name || ""}
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">To WhereHouse</label>
            <input
              type="text"
              className="form-control"
              value={productData?.to_warehouse?.warehouse_name || ""}
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Quantity</label>
            <input
              type="text"
              className="form-control"
              value={productData?.total_quantity || ""}
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Transfer Date</label>
            <input
              type="text"
              className="form-control"
              value={productData?.transfer_date || ""}
              readOnly
            />
          </div>
          <div className="col-md-12 mb-3">
            <label className="form-label">Remark</label>
            <textarea
              className="form-control"
              rows="4"
              value={productData?.remark || ""}
              readOnly
            />
          </div>
        </div>
        <div className="card mt-4">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Transferred Products</h5>
            <button
              className="add-btn"
              onClick={() => setShowProducts(!showProducts)}
            >
              {showProducts ? "Hide Products" : "View Products"}
            </button>
          </div>

          {showProducts && (
            <>
              {totalPages > 1 && (
                <div className="d-flex justify-content-end p-3">
                  <Pagination
                    page={page}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-bordered table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Product Name</th>
                      <th>SKU</th>
                      <th>Price</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>

                  <tbody>
                    {productData?.items?.length > 0 ? (
                      productData.items.map((item, index) => (
                        <tr key={item.id}>
                          <td>{(page - 1) * limit + index + 1}</td>
                          <td>{item.product?.product_name}</td>
                          <td>{item.product?.sku}</td>
                          <td>{item.product?.selling_price}</td>
                          <td>{item.quantity}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No Product Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {totalPages > 1 && (
                  <div className="d-flex justify-content-end mt-3">
                    <Pagination
                      page={page}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewInventryDetail;